import React from 'react';
import successLog from "../../assests/images/success.png";

function SuccessAlert({setSuccess, msg, hide}) {
    return (
        <div className='alertView'>
            <div>
                <div className='title'>Success</div>
                <div className='mainText'>
                    <div className="img-container">
                    <img src={successLog} alt='errorIcon'/></div>
                    <div className="message">{msg}</div>
                </div>
                <div className='actionButton'>
                    <button className='blue btn-ok' onClick={() => {
                        setSuccess(false)
                        if(hide){
                            hide();
                        }
                    }}>Ok</button>
                </div>
            </div>
        </div>
    );
}

export default SuccessAlert;